export default {

	"boterhamshow-is-dicht": [ 0,9864.013605442176 ],
	"deuren_1": [ 11000,3343.673469387756 ],
	"deuren_2": [ 16000,4466.938775510204 ],
	"deuren_3": [ 22000,2795.102040816328 ],
	"deuren_4": [ 26000,2977.9591836734694 ],
	"vlieg-1": [ 30000,2664.0136054421787 ],
	"vlieg-2": [ 34000,3888.0045351473955 ],
	"vlieg-3": [ 39000,2664.0136054421787 ]

}


// WEBPACK FOOTER //
// ./src/components/website/AudioSpriteWebsite.js